import type { NotificationType } from '@cabgo/shared';
import { Bell, CheckCircle2, Flag, Receipt, TriangleAlert } from 'lucide-react';
import type { ReactElement } from 'react';

export function getNotificationIcon(type: NotificationType, size = 18): ReactElement {
  switch (type) {
    case 'DRIVER_CONFIRMED':
      return <CheckCircle2 size={size} />;
    case 'TRIP_COMPLETED':
      return <Flag size={size} />;
    case 'PAYMENT_SLIP_SUBMITTED':
      return <Receipt size={size} />;
    case 'DISPATCH_FAILED':
    case 'REPORT_EXPORT_FAILED':
      return <TriangleAlert size={size} />;
    default:
      return <Bell size={size} />;
  }
}
